import React, { useEffect, Fragment } from 'react';
import { isEmpty, propEq, find, includes } from 'ramda';
import { useTranslation } from 'react-i18next';

import Loader from 'sharedComponents/Loader';
import Seo from 'sharedComponents/Seo';

import useApp from 'reducers/hooks/useApp';
import MessagePresenter from 'presenters/MessagePresenter';
import FirebaseChatPresenter from 'presenters/FirebaseChatPresenter';

import useNotification from 'reducers/hooks/useNotification';
import useChats from 'reducers/hooks/useChats';
import useScreen from 'hooks/useScreen';
import useFirebaseChat from 'reducers/hooks/firebase/useChat';

import DesktopMessages from './components/DesktopMessages';
import WelcomePage from './components/WelcomePage';
import MobileMessages from './components/MobileMessages';

const BuyerMessages = () => {
  const { isDesktop } = useScreen();
  const { t } = useTranslation();

  const {
    chats: firebaseChats,
    isChatsLoaded,
    isChatsLoading,
    loadAndSubscribeToMessages,
    subscribedChatMessagesUids,
    sendMessage,
    changeSelectedChatUid,
    selectedChatUid,
    isChatsIdle,
    readMessages,
    isOnline,
  } = useFirebaseChat();
  const { chats } = useChats();
  const { sendMessageNotification } = useNotification();

  const { currentUser } = useApp();
  const chatsLength = firebaseChats.length;

  useEffect(() => {
    if (chatsLength > 0) {
      const test = FirebaseChatPresenter.uid(firebaseChats[0]);
      handleChatSelect(test);
    }
  }, [chatsLength]);

  const handleChatSelect = uid => {
    const chat = find(propEq('uid', uid), firebaseChats);
    const chatUid = FirebaseChatPresenter.uid(chat);
    changeSelectedChatUid(chatUid);

    const isSubscribedToChatMessages = includes(chatUid, subscribedChatMessagesUids);
    if (isSubscribedToChatMessages) return;
    loadAndSubscribeToMessages(chatUid);
  };

  const handleSendMessage = (participantId, chatUid, message) => {
    sendMessage(participantId, currentUser.id, chatUid, message);
    const params = {
      recepientId: participantId,
      type: MessagePresenter.type(message),
      message: MessagePresenter.data(message),
    };

    sendMessageNotification({ notification: params });
  };

  const handleMessagesRead = chatUid => {
    readMessages(currentUser.id, chatUid);
  };

  const handleUnselectChat = () => {
    changeSelectedChatUid(null);
  };

  if (isChatsLoaded && isEmpty(firebaseChats)) return <WelcomePage />;

  if (isChatsLoading || isChatsIdle) {
    return <Loader fullFill />;
  }

  const MesssagesComponent = isDesktop ? DesktopMessages : MobileMessages;

  return (
    <Fragment>
      <Seo title={t('meta.BuyerMessages.title')} />
      <MesssagesComponent
        isOnline={isOnline}
        currentUser={currentUser}
        onChatSelect={handleChatSelect}
        onMessageSend={handleSendMessage}
        onMessagesRead={handleMessagesRead}
        selectedChatUid={selectedChatUid}
        chats={firebaseChats}
        chatsInfo={chats}
        onUnselectChat={handleUnselectChat}
      />
    </Fragment>
  );
};

export default BuyerMessages;



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/BuyerMessages.js